import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


//======================================
// Partners
//======================================
export function getViewControlManagePartners(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-partners`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Commissions
//======================================
function pathControlPartnerCommissions(commissionId=null) {
  if (commissionId) {
      return `control/partner-commissions/${commissionId}`;
  } else {
      return `control/partner-commissions`;
  }
}

export function createControlPartnerCommissions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlPartnerCommissions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlPartnerCommissions(successCallback, errorCallback, data, commissionId) {
  patchAuth({
    "path": pathControlPartnerCommissions(commissionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlPartnerCommissions(successCallback, errorCallback, commissionId) {
  deleteAuth({
    "path": pathControlPartnerCommissions(commissionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewControlManagePartnerCommissions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-partner-commissions`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Payouts
//======================================
function pathControlPartnerPayouts(payoutId=null) {
  if (payoutId) {
      return `control/partner-payouts/${payoutId}`;
  } else {
      return `control/partner-payouts`;
  }
}

export function createControlPartnerPayouts(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlPartnerPayouts(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlPartnerPayouts(successCallback, errorCallback, data, payoutId) {
  patchAuth({
    "path": pathControlPartnerPayouts(payoutId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlPartnerPayouts(successCallback, errorCallback, payoutId) {
  deleteAuth({
    "path": pathControlPartnerPayouts(payoutId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getControlPartnerPayoutsExportMassPayment(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`control/partner-payouts/export-mass-payment`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


export function getViewControlManagePartnerPayouts(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-partner-payouts`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Referrals
//======================================
function pathControlAffiliateReferrals(referralId=null) {
  if (referralId) {
      return `control/affiliate-referrals/${referralId}`;
  } else {
      return `control/affiliate-referrals`;
  }
}

export function createControlAffiliateReferrals(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlAffiliateReferrals(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlAffiliateReferrals(successCallback, errorCallback, data, referralId) {
  patchAuth({
    "path": pathControlAffiliateReferrals(referralId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlAffiliateReferrals(successCallback, errorCallback, referralId) {
  deleteAuth({
    "path": pathControlAffiliateReferrals(referralId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageAffiliateReferrals(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-affiliate-referrals`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Integrations
//======================================
function pathControlPartnerDeals(dealId=null) {
  if (dealId) {
      return `control/partner-deals/${dealId}`;
  } else {
      return `control/partner-deals`;
  }
}

export function createControlPartnerDeals(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlPartnerDeals(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlPartnerDeals(successCallback, errorCallback, data, dealId) {
  patchAuth({
    "path": pathControlPartnerDeals(dealId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlPartnerDeals(successCallback, errorCallback, dealId) {
  deleteAuth({
    "path": pathControlPartnerDeals(dealId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManagePartnerDeals(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-partner-deals`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewControlPartnerDealShforms(dealId=null) {
  if (dealId) {
      return `view/control/partner-deal-shforms/${dealId}`;
  } else {
      return `view/control/partner-deal-shforms`;
  }
}

export function getViewControlPartnerDealShforms(successCallback, errorCallback, dealId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewControlPartnerDealShforms(dealId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export const URL_CONTROL_PARTNER_DEALS_LOGO_MEDIA = `/${constants.API_VERSION}/control/partner-deals/logo-media`;


//======================================
// Integrations
//======================================
function pathControlIntegrationPartners(integrationId=null) {
  if (integrationId) {
      return `control/integration-partners/${integrationId}`;
  } else {
      return `control/integration-partners`;
  }
}

export function createControlIntegrationPartners(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlIntegrationPartners(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlIntegrationPartners(successCallback, errorCallback, data, integrationId) {
  patchAuth({
    "path": pathControlIntegrationPartners(integrationId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlIntegrationPartners(successCallback, errorCallback, integrationId) {
  deleteAuth({
    "path": pathControlIntegrationPartners(integrationId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageIntegrationPartners(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-integration-partners`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathViewControlIntegrationPartnerShforms(integrationId=null) {
  if (integrationId) {
      return `view/control/integration-partner-shforms/${integrationId}`;
  } else {
      return `view/control/integration-partner-shforms`;
  }
}

export function getViewControlIntegrationPartnerShforms(successCallback, errorCallback, integrationId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewControlIntegrationPartnerShforms(integrationId), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



export const URL_CONTROL_INTEGRATION_PARTNERS_LOGO_MEDIA = `/${constants.API_VERSION}/control/integration-partners/logo-media`;
export const URL_CONTROL_INTEGRATION_PARTNERS_SCREENSHOT_MEDIA = `/${constants.API_VERSION}/control/integration-partners/screenshot-media`;



//======================================
// Integration Partner Options
//======================================
function pathControlIntegrationPartnerOptions(optionId=null) {
  if (optionId) {
      return `control/integration-partner-options/${optionId}`;
  } else {
      return `control/integration-partner-options`;
  }
}

export function createControlIntegrationPartnerOptions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlIntegrationPartnerOptions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlIntegrationPartnerOptions(successCallback, errorCallback, data, optionId) {
  patchAuth({
    "path": pathControlIntegrationPartnerOptions(optionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlIntegrationPartnerOptions(successCallback, errorCallback, optionId) {
  deleteAuth({
    "path": pathControlIntegrationPartnerOptions(optionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageIntegrationPartnerOptions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-integration-partner-options`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}



//======================================
// Agencies
//======================================
function pathControlAgencies(agencyId=null) {
  if (agencyId) {
      return `control/agencies/${agencyId}`;
  } else {
      return `control/agencies`;
  }
}

export function createControlAgencies(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlAgencies(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlAgencies(successCallback, errorCallback, data, agencyId) {
  patchAuth({
    "path": pathControlAgencies(agencyId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlAgencies(successCallback, errorCallback, agencyId) {
  deleteAuth({
    "path": pathControlAgencies(agencyId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageAgencies(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-agencies`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlPreviewAgencyDetails(successCallback, errorCallback, agencyId, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/preview-agency-details/${agencyId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


//======================================
// Agency Options
//======================================
function pathControlAgencyOptions(optionId=null) {
  if (optionId) {
      return `control/agency-options/${optionId}`;
  } else {
      return `control/agency-options`;
  }
}

export function createControlAgencyOptions(successCallback, errorCallback, data) {
  postAuth({
    "path": pathControlAgencyOptions(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}


export function patchControlAgencyOptions(successCallback, errorCallback, data, optionId) {
  patchAuth({
    "path": pathControlAgencyOptions(optionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteControlAgencyOptions(successCallback, errorCallback, optionId) {
  deleteAuth({
    "path": pathControlAgencyOptions(optionId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewControlManageAgencyOptions(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/control/manage-agency-options`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}
